class CustomerService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    adminPortal = {
        query: async (query) => {
            const { data } = await this.axiosInstance.mainInstance.get(`/customer/admin-portal`, {
                params: query,
            });
            return data;
        },
        fetch: async (id) => {
            const { data } = await this.axiosInstance.mainInstance.get(`/customer/admin-portal/${id}`);
            return data;
        },
        create: async (input) => {
            const { data } = await this.axiosInstance.mainInstance.post(`/customer/admin-portal`, input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axiosInstance.mainInstance.put(`/customer/admin-portal/${id}`, input);
            return data;
        },
        subscriptions: {
            fetch: (id) => {
                return this.axiosInstance.socket.connect(`/customer/admin-portal/${id}`);
            },
        },
        contact: {
            create: async (id, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/customer/admin-portal/${id}/contact`, input);
                return data;
            },
            update: async (customerID, contactID, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/customer/admin-portal/${customerID}/contact/${contactID}`, input);
                return data;
            },
            delete: async (customerID, contactID) => {
                const { data } = await this.axiosInstance.mainInstance.delete(`/customer/admin-portal/${customerID}/contact/${contactID}`);
                return data;
            },
        },
        googleAds: {
            authenticateGoogle: async () => {
                const response = await this.axiosInstance.mainInstance.get(`/customer/google-ads/oauth/get-auth-url`, {});
                return response;
            },
            googleAuthCallback: async (searchParams) => {
                const response = await this.axiosInstance.mainInstance.get(`/customer/google-ads/oauth/callback-helper${searchParams}`);
                return response;
            },
        },
        serviceLocation: {
            create: async (id, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/customer/admin-portal/${id}/service-location`, input);
                return data;
            },
        },
        leads: {
            query: async (filters) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/alliance-leads`, {
                    params: { ...filters, limit: filters.limit || 10000 },
                });
                return data;
            },
            fetch: async (id) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/alliance-leads/${id}`);
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/customer/alliance-leads`, input);
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/customer/alliance-leads/${id}`, input);
                return data;
            },
            subscription: {
                query: (filters) => {
                    return this.axiosInstance.socket.connect('/customer/alliance-leads', {
                        params: filters,
                    });
                },
                fetch: (id) => {
                    return this.axiosInstance.socket.connect(`/customer/alliance-leads/${id}`);
                },
            },
            generateToken: async (id) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/customer/checkout/access-token`, {
                    leadID: id,
                });
                return data;
            },
            internalNote: {
                create: async (id, input) => {
                    const { data } = await this.axiosInstance.mainInstance.post(`/customer/alliance-leads/${id}/internal-note`, input);
                    return data;
                },
            },
            quote: {
                create: async (id, input) => {
                    const { data } = await this.axiosInstance.mainInstance.post(`/customer/alliance-leads/${id}/quote`, input);
                    return data;
                },
                delete: async (leadID, quoteID) => {
                    const { data } = await this.axiosInstance.mainInstance.delete(`/customer/alliance-leads/${leadID}/quote/${quoteID}`);
                    return data;
                },
            },
            haulerQuote: {
                create: async (id, input) => {
                    const { data } = await this.axiosInstance.mainInstance.post(`/customer/alliance-leads/${id}/hauler-quote`, input);
                    return data;
                },
                delete: async (leadID, quoteID) => {
                    const { data } = await this.axiosInstance.mainInstance.delete(`/customer/alliance-leads/${leadID}/hauler-quote/${quoteID}`);
                    return data;
                },
            },
            contactEvent: {
                create: async (id, input) => {
                    const { data } = await this.axiosInstance.mainInstance.post(`/customer/alliance-leads/${id}/contact-event`, input);
                    return data;
                },
            },
        },
        merge: async (input) => {
            const { data } = await this.axiosInstance.appAdminInstance.post(`/customer/admin-portal/merge`, input);
            return data;
        },
    };
    appAdmin = {
        updateCustomer: async (id, customer) => {
            const { data } = await this.axiosInstance.appAdminInstance.put(`/customer/admin-portal/${id}`, customer);
            return data;
        },
    };
    /**
     * Represents the customer portal functionality of the Customer service.
     */
    customerPortal = {
        /**
         * Fetches the customer profile from the customer portal.
         * @returns A promise that resolves to the customer profile.
         */
        fetch: async () => {
            const { data } = await this.axiosInstance.mainInstance.get('/customer/customer-portal/profile');
            return data;
        },
        /**
         * Updates the customer profile in the customer portal.
         * @param account - The updated customer profile.
         * @returns A promise that resolves to the updated customer profile.
         */
        update: async (account) => {
            const { data } = await this.axiosInstance.mainInstance.put('/customer/customer-portal/profile', account);
            return data;
        },
        leads: {
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post('/customer/alliance-leads/public', input);
                return data;
            },
        },
    };
    wayste = {
        fetch: async (id) => {
            const { data } = await this.axiosInstance.mainInstance.get(`/customer/${id}`);
            return data;
        },
        query: async (query) => {
            const { data } = await this.axiosInstance.mainInstance.get('/customer', {
                params: query,
            });
            return data;
        },
        create: async (input) => {
            const { data } = await this.axiosInstance.mainInstance.post('/customer', input);
            return data;
        },
        update: async (id, input) => {
            const { data } = await this.axiosInstance.mainInstance.put(`/customer/${id}`, input);
            return data;
        },
        contact: {
            create: async (customerID, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/customer/wayste/${customerID}/customer-contact`, input);
                return data;
            },
            update: async (customerID, contactID, input) => {
                const { data } = await this.axiosInstance.mainInstance.patch(`/customer/wayste/${customerID}/customer-contact/${contactID}`, input);
                return data;
            },
            delete: async (customerID, contactID) => {
                const { data } = await this.axiosInstance.mainInstance.delete(`/customer/wayste/${customerID}/customer-contact/${contactID}`);
                return data;
            },
        },
        signableDocument: {
            fetch: async (id) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/wayste/signable-document/${id}`);
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/customer/wayste/signable-document`, input);
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axiosInstance.mainInstance.patch(`/customer/wayste/signable-document/${id}`, input);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/wayste/signable-document`, {
                    params: query,
                });
                return data;
            },
        },
        waysteCustomerDocument: {
            fetch: async (id) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/wayste/customer-document/${id}`);
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/customer/wayste/customer-document`, input);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/wayste/customer-document`, {
                    params: query,
                });
                return data;
            },
        },
        merge: async (input) => {
            const { data } = await this.axiosInstance.appAdminInstance.post('/customer/merge', input);
            return data;
        },
    };
    waysteDashboard = {
        authenticate: async (token) => {
            const { data } = await this.axiosInstance.mainInstance.get(`customer/wayste-dashboard-token/${token}`);
            if (data.authority) {
                this.axiosInstance.mainInstance.defaults.headers.common.Authorization = `Bearer ${data.authority.token}`;
            }
            return data;
        },
        waysteCustomerDocument: {
            fetch: async (id) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/wayste-dashboard/customer-document/${id}`);
                return data;
            },
            update: async (id, input) => {
                const { data } = await this.axiosInstance.mainInstance.patch(`/customer/wayste-dashboard/customer-document/${id}`, input);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/customer/wayste-dashboard/customer-document`, {
                    params: query,
                });
                return data;
            },
        },
    };
}
export default CustomerService;
//# sourceMappingURL=Customer.service.js.map